// Chakra imports
import { Box, SimpleGrid } from "@chakra-ui/react";
import CardsTable from "./components/CardsTable";
import React from "react";

export default function DataTables() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb='20px'
        spacing={{ base: "20px", xl: "20px" }}>
        <CardsTable />
      </SimpleGrid>
    </Box>
  );
}
